function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'green-wengen': 'rgb(1, 118, 109)','green-engelberg': 'rgb(163, 225, 221)','blue-aletsch': 'rgb(190, 207, 244)','blue-st-moritz': 'rgb(69, 70, 101)','red-verbier': 'rgb(220, 48, 62)','pink-montana': 'rgb(219, 69, 117)','grey-saas-fee': 'rgb(159, 159, 159)','black-laax': 'rgb(17, 17, 17)','pink-flims': 'rgb(246, 207, 208)','rosa-flims': 'rgb(246, 207, 208)','blue-zermatt': 'rgb(60, 88, 153)','green-gstaad': 'rgb(118, 147, 60)','camel-arolla': 'rgb(230, 184, 183)','cream-andermatt': 'rgb(221, 217, 196)','navy': 'rgb(19, 34, 87)','turquoise-adelboden': 'rgb(0, 176, 240)','polar-white': 'rgb(255, 255, 255)','rosa-montana': 'rgb(219, 69, 117)','orange-arosa': 'rgb(254, 115, 20)','grey-zinal': 'rgb(73, 70, 75)','nude-scuol': 'rgb(253, 212, 191)','pink-davos': 'rgb(223, 80, 109)',};

    this.images = {'rouge-et-noir': 'url("//fjorkmerino.ch/cdn/shop/files/Rougeetnoir_120x.png?v=12916346143835918564")','brown-white-logo': 'url("//fjorkmerino.ch/cdn/shop/files/brownwhitelogo_120x.png?v=8258875202673062363")','blanc-et-gris': 'url("//fjorkmerino.ch/cdn/shop/files/whitegrey_120x.png?v=7009307246192554810")','brb': 'url("//fjorkmerino.ch/cdn/shop/files/Rougeetnoir_120x.png?v=12916346143835918564")','turquoise-gris': 'url("//fjorkmerino.ch/cdn/shop/files/turquoisegris_120x.png?v=6187364230464537434")','grey-black': 'url("//fjorkmerino.ch/cdn/shop/files/Greyblack_120x.png?v=9791582416011119304")','gris-noir': 'url("//fjorkmerino.ch/cdn/shop/files/Greyblack_120x.png?v=9791582416011119304")','schwarzes-laax': 'url("//fjorkmerino.ch/cdn/shop/files/schwarz_120x.png?v=9209488793978710382")','grau-saas-fee': 'url("//fjorkmerino.ch/cdn/shop/files/grau_120x.png?v=13240398618873704822")','kaki-black': 'url("//fjorkmerino.ch/cdn/shop/files/kakiblack_120x.png?v=12367116249176701376")','black-red-logo': 'url("//fjorkmerino.ch/cdn/shop/files/cap2_120x.png?v=9430454242226501939")','white-grey-logo': 'url("//fjorkmerino.ch/cdn/shop/files/whitegreylogo_120x.png?v=9946459588488583990")','weiss-grau-logo': 'url("//fjorkmerino.ch/cdn/shop/files/whitegreylogo_120x.png?v=9946459588488583990")','black-white-logo': 'url("//fjorkmerino.ch/cdn/shop/files/cap1_120x.png?v=10636272982922365105")','kaki-black-logo': 'url("//fjorkmerino.ch/cdn/shop/files/cap4_120x.png?v=15096128346416105160")','pink-white-logo': 'url("//fjorkmerino.ch/cdn/shop/files/cap5_120x.png?v=15650025309852704510")','grey-turquoise-logo': 'url("//fjorkmerino.ch/cdn/shop/files/cap3_120x.png?v=793964743219699968")','graues-turkis-logo': 'url("//fjorkmerino.ch/cdn/shop/files/cap3_120x.png?v=793964743219699968")','red-white-logo': 'url("//fjorkmerino.ch/cdn/shop/files/cap7_120x.png?v=10439108535935487263")','black-turquoise-logo': 'url("//fjorkmerino.ch/cdn/shop/files/blackturquoiselogo_120x.png?v=1602589282006240829")','white-black-logo': 'url("//fjorkmerino.ch/cdn/shop/files/whiteblacklogo_120x.png?v=16564381066820630441")','navy-white-logo': 'url("//fjorkmerino.ch/cdn/shop/files/cap6_120x.png?v=4170362761000012474")','bwb': 'url("//fjorkmerino.ch/cdn/shop/files/BWB_120x.png?v=4777901695805613876")','red-blue': 'url("//fjorkmerino.ch/cdn/shop/files/redblue_120x.png?v=1999173597646687533")','green-blue': 'url("//fjorkmerino.ch/cdn/shop/files/greenblue_120x.png?v=11876077417472968717")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
